import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip";
import { parseDateValue } from "@/utils/date";
import { formatDateOnly, getPacificTodayInputValue, toDateOnlyInputValue } from "@/utils/date-only";
import ReactTimeAgo from "react-time-ago";
import cn from "twsx";
import { formatCalendarDate, formatNumericCalendarDate } from "./format-calendar-date";
export default function DateDisplay(t0) {
  const $ = _c(23);
  const {
    date,
    className,
    showFullDate: t1,
    format: t2,
    isDueDate: t3
  } = t0;
  const showFullDate = t1 === undefined ? false : t1;
  const format = t2 === undefined ? showFullDate ? "numeric" : "relative" : t2;
  const isDueDate = t3 === undefined ? false : t3;
  let T0;
  let T1;
  let t4;
  let t5;
  let t6;
  if ($[0] !== className || $[1] !== date || $[2] !== format || $[3] !== isDueDate) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolvedDate = parseDateValue(date);
      if (!resolvedDate) {
        let t7;
        if ($[9] !== className) {
          t7 = cn(className);
          $[9] = className;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        let t8;
        if ($[11] !== t7) {
          t8 = <span className={t7}>-</span>;
          $[11] = t7;
          $[12] = t8;
        } else {
          t8 = $[12];
        }
        t6 = t8;
        break bb0;
      }
      const isOverdue = isDueDate && (format === "date-only" ? toDateOnlyInputValue(resolvedDate) < getPacificTodayInputValue() : resolvedDate < new Date());
      T1 = Tooltip;
      const t7 = isOverdue && "text-red-text";
      let t8;
      if ($[13] !== className || $[14] !== t7) {
        t8 = cn(className, t7);
        $[13] = className;
        $[14] = t7;
        $[15] = t8;
      } else {
        t8 = $[15];
      }
      t5 = <TooltipTrigger><span className={t8}>{format === "date-only" ? formatDateOnly(resolvedDate) : format === "calendar" ? formatCalendarDate(resolvedDate) : format === "numeric-pacific" ? formatNumericCalendarDate(resolvedDate) : format === "numeric" ? resolvedDate.toLocaleDateString("en-US", {
            timeZone: "America/Los_Angeles"
          }) : <ReactTimeAgo date={resolvedDate} locale="en-US" />}</span></TooltipTrigger>;
      T0 = TooltipContent;
      t4 = format === "date-only" ? formatDateOnly(resolvedDate) : resolvedDate.toLocaleString("en-US", {
        timeZone: "America/Los_Angeles",
        timeZoneName: "short"
      });
    }
    $[0] = className;
    $[1] = date;
    $[2] = format;
    $[3] = isDueDate;
    $[4] = T0;
    $[5] = T1;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    T0 = $[4];
    T1 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[16] !== T0 || $[17] !== t4) {
    t7 = <T0>{t4}</T0>;
    $[16] = T0;
    $[17] = t4;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== T1 || $[20] !== t5 || $[21] !== t7) {
    t8 = <T1>{t5}{t7}</T1>;
    $[19] = T1;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}